export default __webpack_public_path__ + "static/media/mammogram.37431957.svg";